import DaoBase from "./base";
import {$shutils} from "../../libs/snnh/snnh";

class DaoBBS extends DaoBase {
    bbsid;
    bbstype;
    biz_view;
    bizid;
    category;
    content;
    /** @type {DaoBBSFile[]} */
    files;
    startdate;
    enddate;
    regdate;
    status;
    title;
    view;
    view_cnt;

    brand = '메가커피';
    brand_image = '/images/mega.png';

    selected = false;

    constructor(json=null) {
        super(json);
        if(!this.regdate) this.regdate = this.startdate;
    }

    get category_str() {
        switch (this.category) {
            case "NOTICE":
            default:
                return '공지사항';
        }
    }

    get date() {
        return $shutils.toDate(this.regdate);
    }

    get date_str() {
        return $shutils.toDateString(this.date, '. ');
    }

    get week_str() {
        return $shutils.toWeekString(this.date, true);
    }
}

export default DaoBBS;


// WEBPACK FOOTER //
// ./src/modules/dao/bbs.js